import { memo } from 'react';
import Typography from '@mui/material/Typography';
//Local files
import { Root, DocPlaceholder, Info } from './FilePreview.styled';
import DocIcon from './DocIcon/DocIcon';
import ErrorWrapper from '../ErrorWrapper/ErrorWrapper';

const FilePreview = ({ name, type, url }) => {
  
  const handleFileClick = () => window.open(url, '_blank').focus();

  return (
    <Root>
      <DocPlaceholder onClick={handleFileClick}>
        <DocIcon type={type} />
      </DocPlaceholder>
      <Info>
        <Typography variant='body2' noWrap sx={{ color: '#fff' }}>{name}</Typography>
      </Info>
    </Root>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <FilePreview {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);